var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-input-autocomplete", {
    ref: "input",
    attrs: {
      "empty-on-focus": "",
      "inpuit-delay": 500,
      fancy: _vm.fancy,
      label: _vm.label,
      items: _vm.foundPurchases,
      open: true,
      icon: _vm.icon,
    },
    on: {
      focus: function ($event) {
        return _vm.focus()
      },
      blur: function ($event) {
        return _vm.onBlur()
      },
      "icon-click": function ($event) {
        return _vm.trigger($event)
      },
      "item-click": function ($event) {
        return _vm.selectPurchase($event)
      },
      "fetch-more": function ($event) {
        return _vm.fetchMore()
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (p) {
          return [
            _c("div", [_vm._v(_vm._s(p.item.ComputedFriendlyID))]),
            p.item.Contact.MainAddress.CompanyName
              ? _c("div", { staticClass: "smaller" }, [
                  _c("span", [
                    _vm._v(_vm._s(p.item.Contact.MainAddress.CompanyName)),
                  ]),
                ])
              : _vm._e(),
          ]
        },
      },
    ]),
    model: {
      value: _vm.input,
      callback: function ($$v) {
        _vm.input = $$v
      },
      expression: "input",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }